export const applyNewTabLinks = (element: HTMLElement): void => {
  const links = element.querySelectorAll("a");
  links.forEach((link) => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });
};
